import React from "react";
import { Upload, Button, Input, Space } from "antd";
import { UploadOutlined, PaperClipOutlined } from "@ant-design/icons";

const VideoUploadInput = ({
  uploadValues,
  setUploadValues,
  uploadProps,
  dummyRequest,
  token,
}) => {
  return (
    <Space direction="vertical" size={12} style={{ width: "100%" }}>
      <Input
        placeholder="Paste link (optional)"
        prefix={<PaperClipOutlined />}
        style={{ width: "100%" }}
        value={uploadValues.isLink ? uploadValues.videoPreviewURL : ""}
        onChange={(e) => {
          const val = e.target.value;
          setUploadValues((prev) => ({
            ...prev,
            videoPreviewURL: val,
            isLink: !!val,
            s3Path: val
              ? { path: null, type: "link", url: val }
              : prev.s3Path,
            videoFileList: val ? [] : prev.videoFileList,
          }));
        }}
      />
      <Upload
        accept=".png,.jpg,.jpeg,.svg,.mp4,.mov,.avi,.pdf"
        {...uploadProps}
        customRequest={dummyRequest}
        maxCount={1}
        showUploadList={false}
        style={{ width: "100%" }}
      >
        <Button
          type="primary"
          icon={<UploadOutlined />}
          style={{
            width: "100%",
            backgroundColor: token?.colorPrimary,
            borderColor: token?.colorPrimary,
          }}
        >
          Record or Upload Video
        </Button>
      </Upload>
    </Space>
  );
};

export default VideoUploadInput;
